import erc20 from "./abis/erc20.json";
import Clips from "./abis/clips.json";
export const CLIPS_ADDRESS = "0xd5dFa18833BaC65C8f01652ab25Ba32A723bE7C7";

export  {
    erc20,
    Clips
  };
  